import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "page-container" }
const _hoisted_2 = { class: "page-header w-full flex flex-wrap gap-3 align-items-center justify-content-between" }
const _hoisted_3 = {
  key: 1,
  class: "pb-2"
}
const _hoisted_4 = {
  key: 0,
  class: "flex flex-wrap gap-3"
}
const _hoisted_5 = {
  key: 1,
  class: "flex gap-3"
}
const _hoisted_6 = { class: "page-content" }

import { computed, ref, onBeforeMount } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { storeToRefs } from 'pinia';
import { useTenantStore, useAuthStore } from '@/store';
import { DeleteTenantConfirm, RestoreTenantConfirm } from '../';
import AppTabMenu from '@/components/AppTabMenu';


export default /*@__PURE__*/_defineComponent({
  __name: 'Tenant',
  setup(__props) {

const route = useRoute();
const id = ref<number>();
const tenantStore = useTenantStore();
const authStore = useAuthStore();
const openDeleteConfirm = ref<boolean>(false);
const openRestoreConfirm = ref<boolean>(false);
const router = useRouter();
const { tenant, selectedTenantRoutes } = storeToRefs(tenantStore);

onBeforeMount(async () => {
  if (route.params.id) {
    id.value = parseInt(route.params.id as string);
    await tenantStore.getTenant(id.value);
  }
});

const profileHeaderText = computed(() => (tenantStore.tenant ? tenantStore.tenant.name : ''));

const openConfirmDeleteTenant = () => (openDeleteConfirm.value = true);

const closeConfirmDeleteTenant = () => (openDeleteConfirm.value = false);

const openConfirmRestoreTenant = () => (openRestoreConfirm.value = true);

const closeConfirmRestoreTenant = () => (openRestoreConfirm.value = false);

const accessTenant = async () => {
  authStore.loading = true;
  const currentTenant = authStore.token?.tenant || undefined;
  let tenantToSwitch = authStore.token;

  if (currentTenant?.id !== tenant?.value?.id && id.value)
    tenantToSwitch = await tenantStore.getTokenToSwitchTenant(id.value);
  if (tenantToSwitch) await authStore.setTenantToSwitch(tenantToSwitch);
};

const redirectToMainPage = async () => await router.push('/admin');

return (_ctx: any,_cache: any) => {
  const _component_Icon = _resolveComponent("Icon")!
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_Skeleton = _resolveComponent("Skeleton")!
  const _component_AppButton = _resolveComponent("AppButton")!
  const _component_RouterView = _resolveComponent("RouterView")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (id.value !== _unref(authStore).masterTenantId)
      ? (_openBlock(), _createBlock(_unref(DeleteTenantConfirm), {
          key: 0,
          id: id.value,
          open: openDeleteConfirm.value,
          onUpdate: redirectToMainPage,
          onCancel: closeConfirmDeleteTenant
        }, null, 8, ["id", "open"]))
      : _createCommentVNode("", true),
    (id.value !== _unref(authStore).masterTenantId)
      ? (_openBlock(), _createBlock(_unref(RestoreTenantConfirm), {
          key: 1,
          id: id.value,
          open: openRestoreConfirm.value,
          onUpdate: redirectToMainPage,
          onCancel: closeConfirmRestoreTenant
        }, null, 8, ["id", "open"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _createVNode(_component_RouterLink, {
          to: "/admin",
          class: "no-underline flex flex-row"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_Icon, {
              name: "arrow_back",
              class: "text-xs"
            }),
            _cache[0] || (_cache[0] = _createElementVNode("div", { class: "link-margin text-xs" }, "Back", -1))
          ]),
          _: 1
        }),
        (_unref(tenantStore).loading)
          ? (_openBlock(), _createBlock(_component_Skeleton, {
              key: 0,
              width: "20rem",
              height: "2.3rem"
            }))
          : (_openBlock(), _createElementBlock("h1", _hoisted_3, _toDisplayString(profileHeaderText.value), 1)),
        _createVNode(_unref(AppTabMenu), { items: _unref(selectedTenantRoutes) }, null, 8, ["items"])
      ]),
      (_unref(tenant))
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            (_unref(tenant)?.deleted_at !== null)
              ? (_openBlock(), _createBlock(_component_AppButton, {
                  key: 0,
                  type: "secondary",
                  text: "Restore",
                  "icon-left": "delete-outline",
                  onClick: openConfirmRestoreTenant
                }))
              : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  (id.value !== _unref(authStore).masterTenantId)
                    ? (_openBlock(), _createBlock(_component_AppButton, {
                        key: 0,
                        type: "secondary",
                        text: "Deactivate",
                        "icon-left": "delete-outline",
                        onClick: openConfirmDeleteTenant
                      }))
                    : _createCommentVNode("", true),
                  (id.value !== _unref(authStore).masterTenantId)
                    ? (_openBlock(), _createBlock(_component_AppButton, {
                        key: 1,
                        type: "secondary",
                        text: "Access Tenant",
                        "icon-right": "arrow_forward_outline",
                        onClick: accessTenant
                      }))
                    : _createCommentVNode("", true)
                ]))
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_RouterView)
    ])
  ]))
}
}

})